"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ImagePreview_1 = require("./ImagePreview");
var useNormalizedUploads_1 = require("./useNormalizedUploads");
var utils_1 = require("utils");
var DropTarget_1 = require("./DropTarget");
var THUMBLIST_STYLES = "flex flex-grow flex-row my-auto mx-0 p-0 flex-wrap";
var INACTIVE_STYLES = "border-contentAreaBorder";
var CONTAINER_STYLES = "flex border content-center w-full";
var ACTIVE_STYLES = "border-actionable";
var minHeight = (0, utils_1.remCalc)(120);
var Gallery = function (_a) {
    var accept = _a.accept, onUpdate = _a.onUpdate, onDelete = _a.onDelete, onUpload = _a.onUpload, maxFiles = _a.maxFiles, previews = _a.previews, getEndpointsForFilenames = _a.getEndpointsForFilenames, label = _a.label;
    var _b = (0, useNormalizedUploads_1.useNormalizedUploads)({
        previews: previews,
        onUpdate: onUpdate,
        onDelete: onDelete,
        onUpload: onUpload,
        maxFiles: maxFiles,
        accept: accept,
        getEndpointsForFilenames: getEndpointsForFilenames,
    }), dropzone = _b.dropzone, renderablePreviews = _b.renderablePreviews, uploads = __rest(_b, ["dropzone", "renderablePreviews"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "p-2 flex-col w-full rounded border border-lochivar-dark" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({}, dropzone.getRootProps(), { className: (0, utils_1.concatStyles)([
                CONTAINER_STYLES,
                dropzone.isDragActive ? ACTIVE_STYLES : INACTIVE_STYLES,
            ]), style: { minHeight: minHeight } }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, dropzone.getInputProps()), void 0), renderablePreviews.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", __assign({ className: THUMBLIST_STYLES }, { children: renderablePreviews.map(function (preview, index) {
                        return ((0, jsx_runtime_1.jsx)(ImagePreview_1.ImagePreview, { primary: index === 0, onSort: uploads.handleSort, preview: preview, onDelete: uploads.handleDeletedFile, index: index, id: preview.id, progress: uploads.progressForUpload(preview.id), onFinishSort: uploads.handleFinishSort }, preview.id));
                    }) }), void 0)) : ((0, jsx_runtime_1.jsx)(DropTarget_1.DropTarget, { label: label, active: dropzone.isDragActive }, void 0))] }), void 0) }), void 0));
};
exports.Gallery = Gallery;
